// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__xYlpt","inputWrap":"CustomTip_inputWrap__pqZ-N"};